import { useCallback } from 'react';
import { getMetricInfo } from '../../constants';

const transform = (alert) => {
  const {
    name,
    attachment,
    cooldown,
    direction,
    emails,
    filterId,
    lifespan: ls,
    metric,
    priority,
    samples: s,
    state,
    threshold: th,
    type,
  } = alert;
  const metricsInfo = getMetricInfo();
  const threshold = metricsInfo[metric].units === 'Mbps' ? parseFloat(th) * 1e6 : parseFloat(th);
  const lifespan = ls ? JSON.stringify(ls) : '';
  const samples = parseInt(s, 10);
  return {
    name,
    attachment,
    cooldown,
    direction,
    emails,
    filterId,
    lifespan,
    metric,
    priority,
    samples,
    state,
    threshold,
    type,
  };
};

const useSave = ({
  alert,
  generalForm,
  advancedForm,
  createAlert,
  updateAlert,
  setAlert,
  setSaving,
}) => {
  const onSave = useCallback(() => {
    generalForm.validateFields().then(() => {
      const currentGeneralSettings = { ...alert, ...generalForm.getFieldsValue() };
      const currentAdvancedSettings = advancedForm ? advancedForm.getFieldsValue() : {};
      const metric = currentGeneralSettings.metric;
      const metricsInfo = getMetricInfo();
      const extra =
        !alert.id && !advancedForm.current ? { samples: metricsInfo[metric].cm_value } : {};
      const newAlert = {
        ...alert,
        ...currentGeneralSettings,
        ...currentAdvancedSettings,
        ...extra,
      };
      setAlert(newAlert);
      setSaving(true);

      if (!newAlert.id) {
        createAlert({
          variables: { payload: transform(newAlert) },
        });
      } else {
        updateAlert({
          variables: { alertId: newAlert.id, payload: transform(newAlert) },
        });
      }
    });
  }, [generalForm.current, alert, advancedForm.current]);
  return onSave;
};

export default useSave;
